import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import {
  listSuppliers,
  listSuppliersNext,
  listOptionSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier,
} from './thunks/marketplace-suppliers';
import {
  listCategories,
  listCategoriesNext,
  listOptionCategories,
  createCategory,
  updateCategory,
  deleteCategory,
} from './thunks/marketplace-categories';
import {
  listProducts,
  listProductsNext,
  createProduct,
  updateProduct,
  deleteProduct,
  getProductVariants,
} from './thunks/marketplace-products';
import { listAllAutocompleteSuppliers, listAllAutocompleteSuppliersNext } from './thunks/autocomplete-suppliers';
import { marketplaceSuppliersReducers } from './extra-reducers/marketplace-suppliers';
import { marketplaceCategoriesReducers } from './extra-reducers/marketplace-categories';
import { selectCategoryReducer, selectProductReducer, selectSupplierReducer } from './reducers';
import { marketplaceProductsReducers } from './extra-reducers/marketplace-products';
import { autocompleteSuppliersReducers } from './extra-reducers/autocomplete-suppliers';

export {
  //suppliers
  listSuppliers,
  listSuppliersNext,
  listOptionSuppliers,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  //autocomplete suppliers
  listAllAutocompleteSuppliers,
  listAllAutocompleteSuppliersNext,
  // categories
  listCategories,
  listCategoriesNext,
  listOptionCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  // products
  listProducts,
  listProductsNext,
  createProduct,
  updateProduct,
  deleteProduct,
  getProductVariants,
};

export const marketplaceManagementSlice = createSlice({
  name: 'marketplaceManagement',
  initialState,
  reducers: {
    selectSupplier: selectSupplierReducer,
    selectCategory: selectCategoryReducer,
    selectProduct: selectProductReducer,
  },
  extraReducers(builder) {
    marketplaceSuppliersReducers(builder);
    marketplaceCategoriesReducers(builder);
    marketplaceProductsReducers(builder);
    autocompleteSuppliersReducers(builder);
  },
});

export const { selectSupplier, selectCategory, selectProduct } = marketplaceManagementSlice.actions;

export default marketplaceManagementSlice.reducer;
